@if (data) {
  <ng-container [ngTemplateOutlet]="itemsCount === 1 ? singleContainer : multiContainer" />

  <ng-template #singleContainer>
    <div #singleContainerDiv class="items-container single">
      <ng-container
        [ngTemplateOutlet]="summaryItem"
        [ngTemplateOutletContext]="{
          item: data.vis.items[0],
          index: 0,
          template: singleItemDisplay,
        }"
      />
    </div>
  </ng-template>

  <ng-template #multiContainer>
    <div #multiContainerDiv class="items-container multi">
      @for (item of data.vis.items; track trackByFn(index, item); let index = $index) {
        <ng-container
          [ngTemplateOutlet]="summaryItem"
          [ngTemplateOutletContext]="{ item: item, index: index, template: multiItemDisplay }"
        />
      }
    </div>
  </ng-template>

  <ng-template #singleItemDisplay let-item="item">
    <span class="item-title">{{ item.header.primary }}</span>

    <svg viewBox="0 0 40 11">
      <defs>
        <filter x="-.5" y="0" width="2" height="1" id="{{ maskId }}">
          <feFlood result="bg" />
        </filter>
      </defs>

      <line
        x1="-1000"
        y1="3.5"
        x2="1000"
        y2="3"
        vector-effect="non-scaling-stroke"
        shape-rendering="crispEdges"
        stroke="black"
      />
      <text
        class="item-value"
        [class.sign-positive]="item.sign === 'positive'"
        [class.sign-negative]="item.sign === 'negative'"
        [attr.filter]="'url(#' + maskId + ')'"
        x="20"
        y="-0.5"
        dy="50%"
        text-anchor="middle"
      >
        {{ item.value }}
      </text>
      <text
        class="item-value"
        [class.sign-positive]="item.sign === 'positive'"
        [class.sign-negative]="item.sign === 'negative'"
        x="20"
        y="-0.5"
        dy="50%"
        text-anchor="middle"
      >
        {{ item.value }}
      </text>
    </svg>
  </ng-template>

  <ng-template #multiItemDisplay let-item="item">
    <span class="item-title">{{ item.header.primary }}</span>
    <svg viewBox="0 0 40 20">
      <text
        class="item-value"
        [class.sign-positive]="item.sign === 'positive'"
        [class.sign-negative]="item.sign === 'negative'"
        x="20"
        y="4"
        dy="50%"
        text-anchor="middle"
      >
        {{ item.value }}
      </text>
    </svg>
  </ng-template>

  <ng-template #summaryItem let-item="item" let-index="index" let-template="template">
    <div
      (click)="resourcesPreviewAvailable() && item.clickable && openResources.emit(item)"
      [class.clickable]="resourcesPreviewAvailable() && item.clickable"
      class="item"
      layout-vertical
      [rtTooltip]
      [rtTooltipEnabled]="!!item.tooltip"
      [rtTooltipTemplate]="tooltipTemplate"
    >
      <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ item: item }" />

      <ng-template #tooltipTemplate>
        @switch (item.tooltip) {
          @case ('funnel-stage-category') {
            <div class="funnel-stage-category-tooltip">
              <div class="funnel-stage-category-tooltip__title">
                <span class="funnel-stage-category-tooltip__title-main">
                  <b>{{ item.header.primary }}</b>
                </span>
              </div>

              <div class="funnel-stage-category-tooltip__subtitle">
                <span class="funnel-stage-category-tooltip__subtitle-main">
                  {{ item.header.secondary }}
                </span>
              </div>
              <rt-divider [hasNoMargin]="true" />
              <div class="funnel-stage-category-tooltip__elements">
                <div class="funnel-stage-category-tooltip__element">
                  <span class="funnel-stage-category-tooltip__element-label">
                    {{ data.dataset.dimensions[1].name }}:
                  </span>
                  <span class="funnel-stage-category-tooltip__element-value">
                    {{ data.dataset.getDataAt([index + 1, 1]) }}
                  </span>
                </div>

                <div class="funnel-stage-category-tooltip__element">
                  <span class="funnel-stage-category-tooltip__element-label">
                    {{ data.dataset.dimensions[2].name }}:
                  </span>
                  <span class="funnel-stage-category-tooltip__element-value">
                    {{ data.dataset.getDataAt([index + 1, 2]) }}
                  </span>
                </div>
              </div>
            </div>
          }
        }
      </ng-template>
    </div>
  </ng-template>
}
